import { GoogleAnalyticsService } from '@/shared/services/GoogleAnalyticsService'
import { useRoute } from 'vue-router'

export const useGoogleAnalytics = () => {
  const route = useRoute()
  const defaultLabel = 'travel'

  const pathLabelsMap: Record<string, string> = {
    'travel-insurance': 'travel',
  }

  const matchedPathKey = Object.keys(pathLabelsMap).find((key) => route?.path.includes(key))

  if (matchedPathKey) {
    const label = pathLabelsMap[matchedPathKey]
    return new GoogleAnalyticsService(label)
  } else {
    return new GoogleAnalyticsService(defaultLabel)
  }
}
